// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2301": "dc2f2f3b","3330": "1852a85d","3573": "ffd50735","4619": "4b303110","5128": "29d4dba2","5237": "893a2200","663": "165fc4d2",}[chunkId] + ".css"
}